// removed by extract-text-webpack-plugin
module.exports = {"with-ellipsis":"RegionResults_with-ellipsis---sb","withEllipsis":"RegionResults_with-ellipsis---sb","region-results":"RegionResults_region-results---sb","regionResults":"RegionResults_region-results---sb","inner-grid":"RegionResults_inner-grid---sb","innerGrid":"RegionResults_inner-grid---sb"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RegionResults/styles.less
// module id = 1680
// module chunks = 0